export enum SendDownloadLinksPanelEvent {
  Close = 'sendDownloadLinksPanelEventClose',
  Send = 'sendDownloadLinksPanelEventSend',
}

export class OnSendDownloadLinksPanelClose extends CustomEvent<{}> {
  constructor() {
    super(SendDownloadLinksPanelEvent.Close, {
      detail: {},
      bubbles: true,
      composed: true,
    });
  }
}

export class OnSendDownloadLinksPanelSend extends CustomEvent<{}> {
  constructor() {
    super(SendDownloadLinksPanelEvent.Send, {
      detail: {},
      bubbles: true,
      composed: true,
    });
  }
}
